'use client';

import { useId } from 'react';

import { FilterSection } from './filter-section.component';
import { FilterOptionsSectionProps } from './filter-options-section.type';

import { Tabs, TabsList, TabsTrigger, TabsVariant } from '@/components/ui/tabs/tabs.component';
import { cn } from '@/utils/cn-tw-merge';

interface FilterToggleGroupSectionProps<TValue extends string> extends FilterOptionsSectionProps<TValue> {
  variant?: TabsVariant;
  optionClassName?: string;
}

export function FilterToggleGroupSection<TValue extends string>({
  label,
  value,
  options,
  onChange,
  variant = 'green',
  optionClassName,
  testId,
  getOptionTestId,
}: FilterToggleGroupSectionProps<TValue>) {
  const labelId = useId();

  return (
    <FilterSection label={label} labelId={labelId} className="gap-1">
      <Tabs value={value} onValueChange={(next) => onChange(next as TValue)}>
        <TabsList
          variant={variant}
          aria-labelledby={labelId}
          className="flex w-full"
          contentClassName="w-full gap-1"
          data-testid={testId}
        >
          {options.map((option) => (
            <TabsTrigger
              key={option.value}
              value={option.value}
              className={cn('min-w-0 flex-1 text-base', optionClassName)}
              data-testid={getOptionTestId?.(option.value)}
            >
              {option.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </FilterSection>
  );
}
